<template>
  <div class="map-pattern">
    <template v-if="showMap">
      <div class="border border-solid border-border-gray p-3 rounded-t-small border-b-0">
        <div v-if="loading" class="text-small" style="">正在获取位置信息。。。</div>
        <div v-else class="relative">
          <p class="text-medium">
            {{ address.add_name }} <span class="text-red pos-icon"><i class="el-icon-location-outline"></i></span>
          </p>
          <p class="text-theme-black-350" v-if="address.R && address.Q">
            <span class="text-medium mr-5" >经度：{{address.R}}</span>
            <span class="text-medium">纬度：{{address.Q}}</span>
          </p>
        </div>
      </div>
    </template>
    <div ref="mapNode" class="cursor-pointer map-wrapper flex relative">
      <span class="m-auto" @click="onClickGetPos">点击获取地理位置</span>
    </div>
    <div v-if="showMap" class="border border-solid border-border-gray p-3 rounded-b-small border-t-0 flex ">
      <div
          @click="getGeolocation"
          class="reset-btn rounded-medium border border-solid border-border-gray mr-3 box-border flex justify-center items-center cursor-pointer" style="width: 40px; height: 34px">
        <span class="pos-icon"><i class="el-icon-location-outline"></i></span>
      </div>
      <div class="flex-1">
        <text-map v-if="!issue.disallowUpdateLocation" :issue="issue" @change="onChange" />
      </div>
    </div>
  </div>
</template>

<script>
import { GD_KEY, getGeocode, transFormPoint } from 'dygc'
import TextMap from '@/questions/components/map/TextMap'

export default {
  name: 'MapPattern',
  components: { TextMap },
  props: {
    issue: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: false,
      address: {},
      showMap: false
    }
  },
  methods: {
    onChange(val) {
      this.setZoomAndCenter(val)
    },
    setZoomAndCenter(item) {
      if (!item) return
      let [lng, lat] = item.location.split(',')
      let center = [parseFloat(lng), parseFloat(lat)]
      this.mapCase.setZoomAndCenter(20, center)
      this.address = {
        Q: lat,
        R: lng,
        add_name: item.name
      }
      this.buildMap(center, this.mapCase)
    },
    onClickGetPos() {
      this.showMap = true
      this.loading = true
      let scriptEl = document.createElement('script')
      scriptEl.src = `https://webapi.amap.com/maps?v=1.4.15&key=${GD_KEY}`
      document.body.appendChild(scriptEl)
      scriptEl.onload = () => {
        this.loadMap()
      }
    },
    getGeolocation() {
      let map = this.mapCase
      let self = this
      let geolocation = new AMap.Geolocation({
        enableHighAccuracy: true, //是否使用高精度定位，默认:true
        timeout: 10000, //超过10秒后停止定位，默认：5s
        showMarker: false,
        showCircle: false,
        showButton: false, //定位按钮的停靠位置
        buttonOffset: new AMap.Pixel(10, 20), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
        zoomToAccuracy: true, //定位成功后是否自动调整地图视野到定位点
        convert: false
      })
      map.addControl(geolocation)
      let [val,lng_lat] = this.issue.value.split('|')
      if(lng_lat) {
        let [lng,lat] = lng_lat.split(',')
       this.buildMap(  [parseFloat(lng), parseFloat(lat)],map)
      }else {
        geolocation.getCurrentPosition(function (status, result) {
          if (status === 'complete') {
            transFormPoint(result.position.R,result.position.Q).then(res=>{
              let [lng, lat] = res.locations.split(',')
              const Q = lat, R = lng
              const lngs = lng.split('.')
              const lats = lat.split('.')
              if(lngs[1]) {
                lngs[1] = lngs[1].slice(0,6)
              }
              if(lats[1]) {
                lats[1] = lats[1].slice(0,6)
              }
              self.getPosComplete({
                position:{
                  lng:lngs.join('.'),lat:lats.join('.'),Q,R
                }
              })
            })
          } else {
            self.getPosError(result)
          }
        })
      }
    },
    loadMap() {
      let el = this.$refs.mapNode
      let map = (this.mapCase = new AMap.Map(el, {
        resizeEnable: true
      }))
      let self = this
      if(!this.issue.disallowUpdateLocation) {
        map.on('click', function(e) {
          self.getPosComplete({
            position: e.lnglat
          })
        })
      }
      AMap.plugin('AMap.ToolBar',()=>{
        const toolBar = new AMap.ToolBar({
          position: {
            top: '110px',
            right: '40px'
          }
        })
        map.addControl(toolBar)
      })
      AMap.plugin('AMap.Geolocation', this.getGeolocation)
    },
    buildMap(center, map) {
      // let el = this.$refs.mapNode
      // let map = new AMap.Map(el, {
      //   resizeEnable: true,
      //   zoom: 30,
      //   center
      // })
      let marker = new AMap.Marker({
        icon: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png',
        position: center
      })
      // let circle = new AMap.Circle({
      //   center: new AMap.LngLat(center[0], center[1]), // 圆心位置
      //   radius: 100, //半径
      //   strokeColor: '#b3e0f2', //线颜色
      //   strokeOpacity: 1, //线透明度
      //   strokeWeight: 3, //线粗细度
      //   fillColor: 'rgb(189, 231, 245)', //填充颜色
      //   fillOpacity: 0.35 //填充透明度
      // })
      map.clearMap()
      map.add(marker)
      // map.add(circle)
      map.setFitView()
    },
    getPosComplete(data) {
      this.loading = false
      let { Q, R ,lat,lng} = data.position
      let center = [parseFloat(R), parseFloat(Q)]
      this.buildMap(center, this.mapCase)
      let item = {
        Q: lat,
        R: lng
      }
      getGeocode(`${R},${Q}`).then(data => {
        item.add_name = data.regeocode.formatted_address
        this.address = item
        this.issue.value = `${item.add_name}|${item.R},${item.Q}`
      })
    },
    getPosError(result) {
      this.loading = false
      this.address = {
        add_name: '获取失败',
        Q: '',
        R: ''
      }
      // this.value= "获取失败"
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.issue.inputValue) {
        this.onClickGetPos()
      }
    })
  }
}
</script>
